import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { ADMIN_ROUTES } from './shared/sidebar/admin-menu-items';
import { CUSTOMER_ROUTES } from './shared/sidebar/customer-menu-items';
import { module_names } from './shared/sidebar/ModulesNameInDB';
import {
  CUSTOM_ROUTES,
  CustomRouteInfo,
} from './shared/sidebar/resource-menu-items';
import { CUSTOM_MODULE_TAB } from './views/common/components/common-modules-tab';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  openRecordDetails: any;
  tag_key: String = '@Resource.Planner_2020';

  constructor(private http: HttpClient) {
    this.openRecordDetails = new EventEmitter<Boolean>();
  }

  openFormSidebar() {
    this.openRecordDetails.emit(true);
  }

  closeFormSidebar() {
    this.openRecordDetails.emit(false);
  }

  authenticateCredentials(url: any, loginParams: any) {
    return this.http.post(url, loginParams);
  }

  getSessionDetails() {
    let encryptedUserDetails = sessionStorage.getItem('user_details');

    if (encryptedUserDetails != null && encryptedUserDetails != undefined) {
      const decryptWithAES = (ciphertext: any, tag_key: any) => {
        const passphrase = tag_key;
        const bytes = CryptoJS.AES.decrypt(ciphertext, passphrase);
        const originalText = bytes.toString(CryptoJS.enc.Utf8);
        return originalText;
      };
      let decryptedUserDetails = decryptWithAES(
        sessionStorage.getItem('user_details'),
        this.tag_key
      );

      return {
        isSessionAlive: true,
        user_details: JSON.parse(decryptedUserDetails),
      };
    } else {
      return { isSessionAlive: false, user_details: null };
    }
  }

  getRolesNPermissions() {
    let sidebarnavItems: CustomRouteInfo[] = [];
    let sessionDetails = this.getSessionDetails();
    let UsersModulesNPermissions =
      sessionDetails.user_details.roleDetails.moduleNPermissions;
    let ROUTES_CLONE = CUSTOM_ROUTES;
    ROUTES_CLONE.forEach((ModuleElement: any) => {
      const indexOfModule = UsersModulesNPermissions.findIndex(
        (permissionElement: any) =>
          permissionElement.moduleName == ModuleElement.module_name
      );
      let mainmoduleItemByIndex = UsersModulesNPermissions[indexOfModule];
      if (mainmoduleItemByIndex) {
        if (ModuleElement.module_name == mainmoduleItemByIndex.moduleName) {
          let prepareSubMenu = [];
          if (ModuleElement.submenu.length > 0) {
            ModuleElement.submenu.forEach((SubModuleElement: any) => {
              const indexOfModule = UsersModulesNPermissions.findIndex(
                (permissionElement: any) =>
                  permissionElement.moduleName == SubModuleElement.module_name
              );
              let permissionCount = 0;
              let submoduleItemByIndex =
                UsersModulesNPermissions[indexOfModule];
              if (submoduleItemByIndex) {
                submoduleItemByIndex.functionalities.forEach(
                  (moduleItemByIndexElement: any) => {
                    if (moduleItemByIndexElement.isPermitted == true) {
                      permissionCount = permissionCount + 1;
                    }
                  }
                );
                if (permissionCount > 0) {
                  if (
                    submoduleItemByIndex.moduleName ==
                    SubModuleElement.module_name
                  ) {
                    prepareSubMenu.push(SubModuleElement);
                  }
                  ModuleElement.submenu = prepareSubMenu;
                  sidebarnavItems.push(ModuleElement);
                }
              }
            });
          } else {
            let permissionCount = 0;
            mainmoduleItemByIndex.functionalities.forEach(
              (moduleItemByIndexElement: any) => {
                if (moduleItemByIndexElement.isPermitted == true) {
                  permissionCount = permissionCount + 1;
                }
              }
            );
            if (permissionCount > 0) {
              sidebarnavItems.push(ModuleElement);
            }
          }
        }
      } else {
        if (ModuleElement.module_name == module_names.static_module) {
          let prepareSubMenu: any = [];
          ModuleElement.submenu.forEach((SubModuleElement: any) => {
            const indexOfModule = UsersModulesNPermissions.findIndex(
              (permissionElement: any) =>
                permissionElement.moduleName == SubModuleElement.module_name
            );

            //   " permissionCount = permissionCount + 1;",
            //   SubModuleElement.module_name
            // );
            let permissionCount = 0;
            let moduleItemByIndex = UsersModulesNPermissions[indexOfModule];
            if (moduleItemByIndex) {
              moduleItemByIndex.functionalities.forEach(
                (moduleItemByIndexElement: any) => {
                  if (moduleItemByIndexElement.isPermitted == true) {
                    permissionCount = permissionCount + 1;
                  }
                }
              );
              if (permissionCount > 0) {
                if (
                  moduleItemByIndex.moduleName == SubModuleElement.module_name
                ) {
                  prepareSubMenu.push(SubModuleElement);
                }
              }
            }
          });
          ModuleElement.submenu = prepareSubMenu;
          if (ModuleElement.submenu.length > 0) {
            sidebarnavItems.push(ModuleElement);
          }
        }
      }
    });
  }

  getMenuItemsBasedOnUserType() {
    let sessionDetails = this.getSessionDetails();
    let sidebarnavItems: CustomRouteInfo[] = [];

    if (sessionDetails.user_details.userType === 'admin') {
      sidebarnavItems = ADMIN_ROUTES;
    } else if (sessionDetails.user_details.userType === 'customer') {
      sidebarnavItems = CUSTOMER_ROUTES;
    } else {
      sidebarnavItems = [];
    }
    return sidebarnavItems;
  }

  // True if the current admin's role has at least ONE permitted functionality
  // for the given module. Used by the sidebar to hide whole menu items when
  // the user has no access to the screen at all. Returns true if there is no
  // roleDetails (defensive: don't hide the menu for users mid-migration).
  hasAnyPermissionInModule(moduleName: string): boolean {
    const session = this.getSessionDetails();
    const roleDetails = session?.user_details?.roleDetails;
    if (!roleDetails || !Array.isArray(roleDetails.moduleNPermissions)) {
      return true;
    }
    const mod = roleDetails.moduleNPermissions.find(
      (m: any) => m && m.moduleName === moduleName
    );
    if (!mod || !Array.isArray(mod.functionalities)) return false;
    return mod.functionalities.some((f: any) => f && f.isPermitted === true);
  }

  hasAccess(module: any, permission: any) {
    let sessionDetails = this.getSessionDetails();
    let UsersModulesNPermissions =
      sessionDetails.user_details.roleDetails.moduleNPermissions;

    //   "user_details.roleDetails.moduleNPermissions",
    //   sessionDetails.user_details.roleDetails.moduleNPermissions
    // );

    //   "UsersModulesNPermissions.find",
    //   sessionDetails.user_details.roleDetails.moduleNPermissions
    // );
    const UserModule: any = UsersModulesNPermissions.find(
      (access: any) => access.moduleName === module
    );
    if (UserModule == null || UserModule == undefined) {
      return false;
    } else {
      const UserPermission: any = UserModule.functionalities.find(
        (access: any) => access.functionalityName === permission
      );
      if (UserPermission == null || UserPermission == undefined) {
        return false;
      } else {
        return UserPermission.isPermitted;
      }
    }
  }

  getPermittedFunctionalities(module: any) {
    let sessionDetails = this.getSessionDetails();
    let UsersModulesNPermissions =
      sessionDetails.user_details.roleDetails.moduleNPermissions;
    const UserModule: any = UsersModulesNPermissions.find(
      (access: any) => access.moduleName === module
    );
    return UserModule.functionalities;
  }

  getRawToken(): string {
    const encrypted = sessionStorage.getItem('access_key');
    if (!encrypted) return '';
    try {
      const bytes = CryptoJS.AES.decrypt(encrypted, this.tag_key as any);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch {
      return '';
    }
  }

  getCurrentUserId() {
    // sessionStorage stores `res.userData` directly as `user_details` (see
    // login.component.ts establishSession) — no nested .userData key.
    return this.getSessionDetails()?.user_details?._id ?? null;
  }
  getCurrentUserName() {
    return this.getSessionDetails()?.user_details?.username ?? null;
  }

  getModuleTabs(module: any) {
    let moduleTabs = CUSTOM_MODULE_TAB;
    return moduleTabs.find((element: any) => element.module_name === module);
  }

  // After a super admin edits the current user's role, the UI can call this
  // to refresh the locally-stored roleDetails (without forcing a re-login).
  // Returns a promise so callers can chain a reload of menu/permissions.
  refreshRoleDetails(): Promise<void> {
    const url = environment.URL + 'prashasan/rbac/me';
    return new Promise((resolve, reject) => {
      this.http.get<any>(url).subscribe({
        next: (res) => {
          try {
            const session = this.getSessionDetails();
            if (!session.isSessionAlive || !session.user_details) {
              return resolve();
            }
            if (res && res.roleDetails) {
              session.user_details.roleDetails = res.roleDetails;
            }
            const encrypted = CryptoJS.AES.encrypt(
              JSON.stringify(session.user_details),
              this.tag_key as any
            ).toString();
            sessionStorage.setItem('user_details', encrypted);
            resolve();
          } catch (e) {
            reject(e);
          }
        },
        error: (err) => reject(err),
      });
    });
  }
}
